import type { ReactElement, Dispatch, SetStateAction } from 'react'
import { useEffect } from 'react'
import { useAppSelector } from '@/store'
import { selectPendingTxById } from '@/store/pendingTxsSlice'
import type { PendingStatus } from '@/store/pendingTxsSlice'

const PendingTxListener = ({
  setTxStatus,
  setTxHash,
  txId,
}: {
  setTxStatus: Dispatch<SetStateAction<PendingStatus | undefined>>
  setTxHash: Dispatch<SetStateAction<string | undefined>>
  txId: string
}): ReactElement => {
  const pendingTx = useAppSelector((state) => selectPendingTxById(state, txId))

  useEffect(() => {
    const { txHash = '', status } = pendingTx || {}
    if (txHash !== '') {
      setTxHash(txHash)
    }
    setTxStatus(status)
  }, [pendingTx, setTxHash, setTxStatus])
  return <></>
}

export default PendingTxListener
